module.exports = __webpack_public_path__ + "img/IMAGE 1.0fd73709.png";